
import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {SecurityAuthApi} from "../../../cad/common/services/api/security/auth/auth";

@Injectable()
export class CaptureAuthTokenInterceptor implements HttpInterceptor {
  constructor(private securityAuthApi: SecurityAuthApi) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only act when the special trigger header is present
    const isMsalAuthTrigger = req.headers.has('X-Auth-Trigger');

    if (isMsalAuthTrigger) {
      const authHeader = req.headers.get('Authorization');
      if (authHeader && /^Bearer\s+/i.test(authHeader)) {
        this.securityAuthApi.storeJWTAuthToken(authHeader);
      }
      // Do NOT modify the request or handle responses—pass through
    }

    return next.handle(req);
  }
}
